import PropTypes from 'prop-types';
import { getCrmTagColor } from 'src/utils/crmTagColors';

NegocioTagPill.propTypes = {
  nome: PropTypes.string,
  cor: PropTypes.string,
  maxWidth: PropTypes.string,
};

// Pill usada tanto pelas tags de negociação quanto pelo status de venda.
// Mesmo desenho do TagItem do chat, mas com classes literais (ver crmTagColors.js).
export default function NegocioTagPill({ nome, cor, maxWidth = 'max-w-[90px]' }) {
  const { pill, dot } = getCrmTagColor(cor);

  return (
    <div
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border ${pill} ${maxWidth}`}
      title={nome}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot} shrink-0`} />
      <span className="text-[10px] font-medium truncate leading-tight">{nome}</span>
    </div>
  );
}
